module.exports = __webpack_public_path__ + "images/for_company_page/media_pedia_5a083991d2afd6cab74cd2dd7ecc9fb6.png";